module.exports = [{
      plugin: require('/Users/alessio.masucci/Code/yoox/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-XXXXXXXX-X","anonymize":true},
    },{
      plugin: require('/Users/alessio.masucci/Code/yoox/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
